import React, { useEffect,useState } from "react";
import { Button, Empty,Pagination,Select } from "antd";
import "./resumedatabase.scss";
import FilterResumeDataBase from "../filterResumeDataBase";
import ResumeSearchTableSelectable from "../ResumeSearchTableSelectable";
import useResumeDataBaseStore from "../../store/resumedatabasesearch.store";
import { GetOwnership } from "../../helper/commonFunctions";

export default function ResumeDataBase(props) {

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const { getResumesFromDatabase, resumeDataBaseDetails, resumeDataBaseTotalCount } = useResumeDataBaseStore();


  const titleList = [
    "Select",
    "Sr. No.",  
    "Resume ID",
    "Name", 
    "Email",
    "Phone",
    "Version",
    "Upgrade Status",
    "Indexing Status",
    "Resume Date",
    "Method",
    "Owner Name",
    "Last Updated On",
    "Resume Source",
    "Ownsership",
    "Resume Histroy"
  ];

  

  const rDetailData = resumeDataBaseDetails ?.map((item, idx) => {
    var dbVersion = JSON.parse(localStorage.getItem("dbversions"))
    console.log("dbversions", dbVersion.resumedbversion )
    var sOwner = GetOwnership(item);    
    return {
      select:"",
      id: (idx + 1)+ (currentPage-1)*pageSize, 
      resumeID:item.qhrid,
      name: item.personaldetail.name,
      email: item.personaldetail.email,
      mobile: item.personaldetail.mobile,
      version:item.version != undefined?item.version:"Upgrade Pending",
      upgradeStatus: item.version != dbVersion?.resumedbversion?"Upgrade Pending":"OK",
      indexingStatus: item.resumeindexed ? "OK" : "Not Done",
      resumeDate: item.firstuploadedby.resumedate,
      method: item.firstuploadedby.method,
      sName: sOwner.sourceName,
      dateAdded: sOwner.sourceDate,
      resumeSource: item.firstuploadedby.resumesource,
      ownershipStatus: item.firstuploadedby.resumeownership,
      resumehistory: "Click Here"
    };
  });

  return (
    <div className="sourcing-wrapper">
      <div>
      <FilterResumeDataBase
        filtername = {"getResumesFromDatabase"}
        initResumeUpgrade = {"All"}
        initResumeIndexed = {"All"}
        initResumeDate = {"All"}
        initResumeYear = {"2026"}
        initResumeMonth = {"All"}
        pageNo = {currentPage}
        pageSize = {pageSize}        
        enableResumeUpgrade
        enableResumeIndexed
        enableResumeYear
        enableResumeMonth
        enableTeamMember
        handleFilter={getResumesFromDatabase}
        setCurrentPage={setCurrentPage}
      />
      <div></div>
      </div>
      <div className="sourcing-title">
       ({resumeDataBaseTotalCount || 0}){" "} Results Found 
      </div>
      <div>
        {rDetailData?.length > 0 ? (
          <ResumeSearchTableSelectable
            isClickable={true}
            titleList={titleList}
            data={rDetailData}
            columnWidth={[
              50, 100, 100, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,200,200,200
            ]}
          />
        ) : (
          <Empty style={{ margin: "60px" }} />
        )}        
      </div>
       <Pagination
              style={{ margin: "20px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={resumeDataBaseTotalCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
            />      

    </div>
  );
}
